import { QueryClient, useQuery } from '@tanstack/react-query';

import { isAxiosError } from '@/shared/lib/error';
import { QueryKey } from '@/types/query';
import { NylasConnectionStatus, NylasConnectionStatusViewModel, toNylasConnectionStatusViewModel } from '../model';
import { nylasCalendarManageConnectionModalClient } from './client';

export const useGetNylasConnectionStatusQuery = () => {
  return useQuery<NylasConnectionStatusViewModel>({
    queryKey: [QueryKey.useGetNylasConnectionStatusQuery],
    queryFn: async () => {
      try {
        const { data } = await nylasCalendarManageConnectionModalClient.getNylasConnectionStatus();

        return toNylasConnectionStatusViewModel(data);
      } catch (error) {
        if (isAxiosError(error)) {
          return {
            calendar: { connected: false, status: NylasConnectionStatus.Error },
            email: { connected: false, status: NylasConnectionStatus.Error },
          };
        }

        throw error;
      }
    },
    retry: false,
  });
};

useGetNylasConnectionStatusQuery.fetchOrCache = async (queryClient: QueryClient) => {
  const cache = queryClient.getQueryData<NylasConnectionStatusViewModel>([QueryKey.useGetNylasConnectionStatusQuery]);
  if (cache) return cache;

  const { data } = await nylasCalendarManageConnectionModalClient.getNylasConnectionStatus();
  const viewModel = toNylasConnectionStatusViewModel(data);

  queryClient.setQueryData([QueryKey.useGetNylasConnectionStatusQuery], viewModel);

  return viewModel;
};
